import { WmIconDirective } from '../../shared/wm-icon.directive';

import {
  CdkDrag,
  CdkDragDrop,
  CdkDragHandle,
  CdkDropList,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [
  CommonModule,
  MatButtonModule,
  MatDividerModule,
  MatListModule,
  MatTooltipModule,
  TranslateModule,
];

export const COMPONENTS = [FaIconComponent];

export const DIRECTIVES = [
  WmIconDirective,
  CdkDropList,
  CdkDrag,
  CdkDragHandle,
];

@Component({
  selector: 'app-epp-settings',
  templateUrl: './epp-settings.component.html',
  styleUrls: ['./epp-settings.component.scss'],
  imports: [
    ...MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    MatCheckbox,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
  ],
})
export class EppSettingsComponent {
  parameterSets = input<string[]>([]);
  resolutions = input<any[]>([]);
  selectedResolution = input<any>();
  settingsParametersByResolutionAndSet = input<
    Record<string, Record<string, any[]>>
  >({});
  isMobilePlatform = input<boolean>(false);

  restoreStandardSettings = output<void>();
  cancelSettings = output<void>();
  saveSettings = output<void>();
  parameterSelectionChange = output<{
    event: MatSelectionListChange;
    resolution: any;
    parameterset: string;
  }>();
  drop = output<{
    event: CdkDragDrop<any[]>;
    resolution: any;
    parameterset: string;
  }>();
  selectAllChange = output<{
    checked: boolean;
    resolution: any;
    parameterset: string;
  }>();

  getResolutionKey(resolution: any): string {
    return `${resolution.days}_${resolution.hourly}`;
  }

  getSettingsParameters(resolution: any, parameterset: string): any[] {
    const resolutionKey = this.getResolutionKey(resolution);
    return (
      this.settingsParametersByResolutionAndSet()?.[resolutionKey]?.[
        parameterset
      ] ?? []
    );
  }

  hasSettingsParameters(resolution: any, parameterset: string): boolean {
    return this.getSettingsParameters(resolution, parameterset).length > 0;
  }

  getSelectedParametersCountForResolutionAndSet(
    resolution: any,
    parameterset: string
  ): number {
    return this.getSettingsParameters(resolution, parameterset).filter(
      entry => entry.selected
    ).length;
  }

  getTotalParametersCountForResolutionAndSet(
    resolution: any,
    parameterset: string
  ): number {
    return this.getSettingsParameters(resolution, parameterset).length;
  }

  isAllSelected(resolution: any, parameterset: string): boolean {
    const params = this.getSettingsParameters(resolution, parameterset);
    return params.length > 0 && params.every(entry => entry.selected);
  }

  isSomeSelected(resolution: any, parameterset: string): boolean {
    const params = this.getSettingsParameters(resolution, parameterset);
    const selectedCount = params.filter(entry => entry.selected).length;
    return selectedCount > 0 && selectedCount < params.length;
  }

  onRestoreStandardSettings(): void {
    this.restoreStandardSettings.emit();
  }

  onCancelSettings(): void {
    this.cancelSettings.emit();
  }

  onSaveSettings(): void {
    this.saveSettings.emit();
  }

  onDrop(
    event: CdkDragDrop<any[]>,
    resolution: any,
    parameterset: string
  ): void {
    this.drop.emit({ event, resolution, parameterset });
  }

  onParameterSelectionChange(
    event: MatSelectionListChange,
    resolution: any,
    parameterset: string
  ): void {
    this.parameterSelectionChange.emit({ event, resolution, parameterset });
  }

  toggleSelectAll(
    checked: boolean,
    resolution: any,
    parameterset: string
  ): void {
    this.selectAllChange.emit({ checked, resolution, parameterset });
  }
}
